import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=55abfe03&scoped=true"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"
import style0 from "./multiple.vue?vue&type=style&index=0&id=55abfe03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abfe03",
  null
  
)

export default component.exports